import React, { useState } from "react"
import { Link as PrismicLink } from "prismic-reactjs"

import { Element } from "legacy/components/shared/base"
import { InteractiveListItemType } from "types/shared-components"
import Link from "legacy/components/shared/Link"
import ListItemHeadline from "./ListItemHeadline"
import { Maybe } from "types/Maybe"
import RichText from "legacy/components/shared/RichText"

interface OwnProps {
  data: Maybe<InteractiveListItemType>
  isLast: boolean
}

export type ListItemType = OwnProps

const ListItem: React.FC<ListItemType> = ({
  data,
  isLast,
}): React.ReactElement | null => {
  if (!data) return null

  const {
    button_text,
    button_url,
    expandable_list_item,
    list_item_name,
    wysiwyg,
  } = data
  const [isOpen, setIsOpen] = useState(!expandable_list_item)

  return (
    <Element
      as="li"
      borderBottom={isLast ? "none" : "1SolidNavy"}
      mb={!isLast ? ["40", "65"] : 0}
      pb={!isLast ? ["40", "65"] : 0}
      width="100%"
    >
      <ListItemHeadline
        headline={list_item_name?.richText}
        isExpandable={expandable_list_item}
        isOpen={isOpen}
        handleInteraction={setIsOpen}
      />
      <Element
        maxHeight={isOpen ? "800px" : 0}
        overflow="hidden"
        transition="all 0.5s ease"
      >
        <RichText mt={["15", "25"]} render={wysiwyg?.richText} />
        {button_text && button_url ? (
          <Link
            fontSize={["13", "18"]}
            mt={["20", "40"]}
            to={PrismicLink.url(button_url)}
            variant="buttonSecondary"
          >
            {button_text}
          </Link>
        ) : null}
      </Element>
    </Element>
  )
}

export default ListItem
